import React, { useState } from 'react';
import { Tag, Space, Dropdown, Menu } from 'antd';
import PropTypes from 'prop-types';

const OverflowSpace = ({ items, maxVisible = 3, direction = 'horizontal', color = '#1a1a1a', borderColor = null }) => {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = showAll ? items : items.slice(0, maxVisible);
  const hiddenItems = items.slice(maxVisible);
  const hiddenItemsCount = hiddenItems.length;

  const tagStyle = {
    background: 'transparent',
    border: `1px solid ${borderColor || color}`,
    color,
    cursor: 'pointer',
  };

  const menu = (
    <Menu>
      {hiddenItems.map(({ label, key, onClick }) => (
        <Menu.Item key={key} onClick={onClick}>
          {label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Space direction={direction} wrap>
      {visibleItems.map(({ label, key, onClick }) => (
        <Tag key={key} onClick={onClick} style={tagStyle}>
          {label}
        </Tag>
      ))}

      {hiddenItemsCount > 0 && !showAll && (
        <Dropdown overlay={menu} trigger={['hover']}>
          <Tag style={tagStyle}>
            +{hiddenItemsCount}
          </Tag>
        </Dropdown>
      )}

      {showAll && (
        <Tag onClick={() => setShowAll(false)} style={tagStyle}>
          Show Less
        </Tag>
      )}
    </Space>
  );
};

OverflowSpace.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      key: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })
  ).isRequired,
  maxVisible: PropTypes.number,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  color: PropTypes.string,
  borderColor: PropTypes.string,
};

export default OverflowSpace;
